export default "__VITE_ASSET__Bnfn9NjX__"